import { getConfig } from "./config";
import { fetchAuthSession } from 'aws-amplify/auth';

export const request = async (endpoint, options = {}) => {
  const cfg = await getConfig();
  const baseURL = cfg.poln.poln_api_base_url
  const session = await fetchAuthSession();

  const token = session.tokens?.accessToken.toString();


  const {
    method = 'GET',
    body = null,
    queryParams = {},
    headers = {},
    notify = true,
    skipRequestCasting = false,
    skipThrow = false,
    responseCasting = true,
  } = options;

  const url = new URL(`${baseURL}${endpoint}`);
  Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));

  const config = {
    method,
    headers: {
      ...(token ? { 'Authorization': token } : {}),
      ...(skipRequestCasting ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    },
    // eslint-disable-next-line no-nested-ternary
    body: body ? (skipRequestCasting ? body : JSON.stringify(body)) : null,
  };
  let response;

  try {
    response = await fetch(url, config);
    if (!responseCasting) return response;

    if (!response.ok) {
      const text = await response.text();
      const textJson = JSON.parse(text)

      if (notify && textJson.type !== 'TEMP_FAILURE') {
        // notifyError(textJson.message);
      }
      if (skipThrow) return {
        body: textJson,
        statusCode: response.status,
        ok: response.ok,
      };

      throw new Error(textJson.message);
    }

    const data = await response.json();

    if (data.error && notify) {
      // notifyError(data.message);
    }

    return {
      body: data,
      statusCode: response.status,
      ok: response.ok,
    };
  } catch (error) {
    // if (notify) {
    //   notifyError(
    //     error.name === 'TypeError'
    //       ? "Hmm.. something didn't work. Can you try again in a few moments?"
    //       : error.message
    //   );
    // }
    if (skipThrow) return { error: error.message };
    throw new Error(`Error: ${error.message}`);
  }
};